import React from 'react'
import {connect} from 'dva'
import {component_tool, framework_tool} from '@/tool'
import {reduxTemplateCofig, templateConfig} from './config'
import {handleExport} from './utils';

let {WizContainer, WizReduxTemplate} = framework_tool

let {WizBrowserExport} = component_tool

class InterviewResume extends WizContainer {

  componentName = 'InterviewResume'

  constructor(props) {
    super(props)
    this.state = {}
  }

  _handleFile(nextProps, nextState, key) {
    let {code, data, msg} = nextProps[key]
    if (code === 1) {
      let columns = [{
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      }, {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '经销商名称',
        field: 'org_dealer_name',
        width: 30,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '组织编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      },{
        headerName: '任职状态',
        field: 'jobStateStr',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      },{
        headerName: '预估开业时间',
        field: 'openTimeStr',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '品牌',
        field: 'brandName',
        width: 30,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '创建时间',
        field: 'createTime',
        width: 40,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '申请面试',
        field: 'applyTimesStr',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '提交状态',
        field: 'submitState',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '提交简历时间',
        field: 'submitTime',
        width: 40,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '面试状态',
        field: 'interviewState',
        width: 20,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }, {
        headerName: '面试简历时间',
        field: 'interviewTime',
        width: 40,
        cellStyle: {textAlign: 'left'},
        style: {alignment: {vertical: 'middle', horizontal: 'center'}}
      }]

      let rows = data.map(item => {
        let {submitState, interviewState, dealerName, orgName} = item
        let org_dealer_name = orgName;
        if (dealerName != null && dealerName != '' && dealerName != undefined) {
          org_dealer_name = dealerName;
        }
        item.org_dealer_name = org_dealer_name;
        switch (submitState) {
          case 0:
            item.submitState = '未提交'
            break
          case 1:
            item.submitState = '已提交'
            break
          default:
            item.submitState = ''
        }
        switch (interviewState) {
          case 0:
            item.interviewState = '待面试'
            break
          case 1:
            item.interviewState = '已通过'
            break
          case 2:
            item.interviewState = '未通过'
            break
          default:
            item.interviewState = ''
        }
        return item
      })

      WizBrowserExport({
        title: '学员简历',
        sheetName: '学员简历',
        columns: columns.filter((_, index) => index),
        rows,
        filename: '学员简历.xlsx',
      })
      return true
    } else {
      wizNotice.error(msg)
      return false
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(this),
      apiDataFormat: {
        export: this._handleFile,
        exportResume: handleExport.bind(this, {title: '学员简历', column: []}),
        exportMbti: handleExport.bind(this, {title: '性格测评报告', column: []}),
      }
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
}

export default connect(mapStateToProps)(InterviewResume)
